<template>
  <div>
    <el-container style="height:100vh;">
      <el-aside class='x-flex' style='width: unset;position: relative;overflow: unset;'>
        <!-- 主菜单 -->
        <div class="main-menu" style="background: #031A43;">
          <div class="x-text-c x-p-t-20  x-p-b-10">
            <img :src="$store.state.oem.logo" style="width: 40rem;height: 40rem;" alt="">
            <!-- <div style="font-size: 14px; color: #fff;">服务商系统</div> -->
          </div>
          <!-- <div v-else class="x-text-c x-p-t-20  x-p-b-10">
            <img src="@/assets/img/oem/lianglimi-logo.png" style="width: 70rem;height: 70rem;" alt="">
          </div> -->
          <!-- 使用Element UI的导航组件 -->
          <el-menu class="el-menu-vertical" :default-active="activerouter" background-color="#031A43" unique-opened
            text-color="#fff" active-text-color="#fff" :router="false">
            <!-- @select="handleMenuSelect" -->
            <template v-for="(item, index) in navList">
              <!-- 判断是否有子菜单 -->
              <template v-if="item.data && Array.isArray(item.data) && item.data.length > 0">
                <!-- 有子菜单的情况 -->
                <el-submenu :index="String(item.id)" :key="item.id" :class="{ 'is-active': item.select }">
                  <template slot="title">
                    <div class="x-flex x-col-center x-w100p">
                      <img v-if="item.img" :src="item.img" style="width: 16rem; height: 16rem; margin-right: 8rem;">
                      <span>{{ fLng(item.name, 'index') }}</span>
                    </div>
                  </template>
                  <!-- 渲染二级菜单项 -->
                  <template v-for="subItem in item.data">
                    <el-menu-item :index="subItem.path.replace('/', '')" @click="subNavItemClick(subItem)">
                      <span>{{ fLng(subItem.name, 'index') }}</span>
                    </el-menu-item>
                  </template>
                </el-submenu>
              </template>
              <template v-else>
                <!-- 没有子菜单的情况，直接作为菜单项处理 -->
                <el-menu-item :key="item.id" :index="String(item.id)" @click="handleNoSubMenuClick(item)">
                  <div class="x-flex x-col-center x-w100p">
                    <img v-if="item.img" :src="item.img" style="width: 16rem; height: 16rem; margin-right: 8rem;">
                    <span>{{ fLng(item.name, 'index') }}</span>
                  </div>
                </el-menu-item>
              </template>
            </template>
          </el-menu>
        </div>
      </el-aside>
      <el-container style="overflow: auto;min-width: 800rem;background: #031A43;">
        <el-header height="" class="x-flex x-row-between x-w100p x-p-t-10 x-p-b-10" style="border-radius: 10rem 0 0 0;">
          <div class="x-flex">
            <div class="x-m-r-5 x-p-r-5 x-bd-right">
              <i class="el-icon-s-home"></i>
            </div>
            <div class="x-font-14 x-p-l-5">
              {{ firstTitle }} / {{ breadcrumb }}
            </div>
          </div>
          <div class="right">
            <div class="x-p-r-10">
              <el-select v-model="navSelectVal" size="small" filterable placeholder="搜索功能菜单" @change="fNav">
                <el-option v-for="item in allNavList" :key="item.path" :label="item.name" :value="item.path">
                </el-option>
              </el-select>
            </div>
            <div class='x-m-r-20 ' style="color: #606266;font-size: 14rem;">
              {{ fLng('机构', 'index') }}：{{ $store.state.smCloud.org_name }}（{{ $store.state.smCloud.org_id }}）
            </div>
            <img src="../assets/img/user_logo.png" alt="" />
            <el-dropdown>
              <span class="el-dropdown-link x-cur-poi">
                {{ $store.state.smCloud.user_name }}（{{ $store.state.smCloud.user_id }}）<i
                  class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <div @click="changePassword = true">{{ fLng('修改密码', 'index') }}</div>
                </el-dropdown-item>
                <el-dropdown-item v-if="$store.state.smCloud.mall_num > 1">
                  <div @click="logout('switchMall')">{{ fLng('切换门店', 'index') }}</div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div @click="logout('logout')">{{ fLng('注销登录', 'index') }}</div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-header>
        <Tabs class='bgc-f' style="width: 100%; height: 40rem; " @refresh-page="refresh" />
        <el-main class='x-flex-1 x-w100p bgc-f' style='overflow: auto;min-height:700rem;min-width: 800rem;'>
          <!-- <el-card style="width: 100%; height: 70rem"> -->
          <!-- </el-card> -->
          <keep-alive>
            <router-view ref="mainView" />
          </keep-alive>
          <!-- <router-view style='min-height:700rem;'></router-view> -->
        </el-main>
      </el-container>
    </el-container>
    <!-- 修改密码的弹窗 -->
    <el-dialog :visible.sync="changePassword" width="400px" :close-on-click-modal="false" :show-close="false"
      :close-on-press-escape="false" class="pl-edit-dialog">
      <div class="x-sm-pop-head">
        <div class="x-flex">
          <div class='x-flex x-h50 x-m-r-20'>{{ fLng('修改密码', 'vip') }}
          </div>
        </div>
        <div class="x-flex ">
          <i class="el-icon-close x-font-16 x-p-2 " style="cursor: pointer; color:#808080 ;"
            @click="changePassword = false"></i>
        </div>
      </div>
      <div class="x-w100p x-p-30" style="">

        <!-- 新密码 -->
        <div class="x-w100p x-h42 x-p-b-10 x-d-flex x-lh-32">
          <div class="x-w70 x-d-flex x-row-right x-p-r-10">
            <div>新密码</div>
          </div>
          <div class="x-flex-1 x-w100p">
            <el-input size="small" v-model="newPassword" placeholder="" show-password></el-input>
          </div>
        </div>
        <!-- 确认密码 -->
        <div class="x-w100p x-h42  x-d-flex x-lh-32">
          <div class="x-w70 x-d-flex x-row-right x-p-r-10">
            <div>确认密码</div>
          </div>
          <div class="x-flex-1 x-w100p">
            <el-input size="small" v-model="confirmPassword" placeholder="" show-password></el-input>
          </div>
        </div>

      </div>
      <!-- 确定&取消 -->
      <div class="x-sm-pop-foot">
        <xButton width="70px" class="x-p-l-10" border="1px solid #DCDFE6" bgc="#fff" color="#242424"
          @click.native="changePassword = false">取消</xButton>
        <xButton width="70px" class="x-p-l-10" @click.native="determineAdd">确定</xButton>
      </div>
    </el-dialog>
    <!-- 导航菜单已替换为Element UI组件 -->
  </div>
</template>

<script>
import eventBus from '../assets/js/bus.js'
import Tabs from "@/components/tabs.vue";
import navList from "@/assets/listData/listData.js";

const HIDDEN_MENU_NAMES_FOR_NON_ADMIN = ['外卖团购', '三方码库']
const NO_AUTH_CHECK_MENU_AUTH_IDS = ['cpmk_wmtg', 'cpmk_sfmk']

export default {
  components: {
    Tabs,
  },
  data() {
    return {
      showImg: false,
      userName: this.$store.state.smCloud.userName,
      path: "/orgAdmin",
      firstTitle: '概况',
      oldPwd: "",
      newPwd: "",
      confirmPwd: "",
      openeds: ['100', '200', '201', '202', '203', '300', '301', '400', '500'],
      activerouter: '/dish',
      langList: [{
        label: '中文',
        value: 'zh-CN'
      }, {
        label: 'English',
        value: 'en-US'
      },],
      hoverActive: '',
      clickDisplaySub: false,
      breadcrumb: '营业概况',
      navList: [],
      //窗口大小
      screenWidth: document.body.offsetWidth,
      // 修改密码
      changePassword: false,
      newPassword: "",
      confirmPassword: "",
      breadcrumbPath: "",
      breadcrumbName: "",

      navSelectVal: '',

    };
  },
  computed: {
    key() {
      return this.$route.path + Math.random();
    },
    allNavList() {
      const list = [];
      if (this.navList && Array.isArray(this.navList)) {
        this.navList.forEach(mainItem => {
          if (mainItem.data && Array.isArray(mainItem.data)) {
            mainItem.data.forEach(subItem => {
              list.push({
                name: subItem.name,
                path: subItem.path,
                mainName: mainItem.name, // 主菜单名称
              });
            });
          }
        });
      }
      return list;
    },
  },
  beforeCreate() {

  },
  created() {
    console.log(this.$store.state.oem)
    //根据版本显示菜单，使用深拷贝避免修改原始数据
    const originalNavList = this.$store.state.smCloud.saas_type_id == 'sipLs' ?
      (Array.isArray(navList.lsNavList) ? navList.lsNavList : []) :
      (Array.isArray(navList.cyNavList) ? navList.cyNavList : []);

    // 深拷贝原始菜单数据，确保不会修改原始引用
    let tempNavList = JSON.parse(JSON.stringify(originalNavList));

    // 确保navList是数组
    if (!Array.isArray(tempNavList)) {
      tempNavList = [];
    }

    // 处理可能的重复键问题
    if (tempNavList.length > 0) {
      // 确保所有主菜单项都有唯一ID
      const mainIds = new Set();
      tempNavList = tempNavList.filter(item => {
        if (mainIds.has(item.id)) return false;
        mainIds.add(item.id);
        // 确保子菜单项也有唯一ID
        if (Array.isArray(item.data)) {
          const subIds = new Set();
          // 创建子菜单项的新数组，而不是直接修改原数组
          item.data = item.data.filter(subItem => {
            if (subIds.has(subItem.id)) return false;
            subIds.add(subItem.id);
            return true;
          });
        }
        return true;
      });
    }

    // "[\"激活码库\",\"机构员工\",\"下级机构\",\"划拨明细\",\"员工权限\",\"划拨统计\",\"商店订单\",\"商户信息\",\"门店信息\",\"图片仓库\",\"尚米PAY\"]"
    // 根据权限来显示隐藏菜单
    if (this.$store.state.smCloud.org_id != '320250710') {
      const auth_ja = this.$store.state.smCloud.auth_ja;
      if (auth_ja) {
        let authList = [];
        try {
          authList = JSON.parse(auth_ja);
        } catch (e) {
          console.error('权限数据解析失败，使用空权限列表', e);
          authList = [];
        }

        // 首先过滤每个主菜单项的子菜单
        tempNavList.forEach(mainItem => {
          if (mainItem.data && Array.isArray(mainItem.data)) {
            // 创建新的过滤后的子菜单数组
            // 下级码库不单独配权限，有激活码库就显示
            mainItem.data = mainItem.data.filter(subItem => {
              if (subItem.name === '下级码库') {
                return authList.includes('下级码库') || authList.includes('激活码库')
              }
              return authList.includes(subItem.name)
            });
          }
        });

        // 然后过滤掉那些子菜单为空的父级菜单
        tempNavList = tempNavList.filter(mainItem => {
          // 对于有子菜单的项目，只有当子菜单不为空时才保留
          if (mainItem.data && Array.isArray(mainItem.data)) {
            return mainItem.data.length > 0;
          }
          // 对于没有子菜单的项目，直接保留
          return true;
        });
      }

      // 非 320250710 机构强制隐藏菜单：外卖团购、三方码库
      tempNavList.forEach(mainItem => {
        if (mainItem.data && Array.isArray(mainItem.data)) {
          mainItem.data = mainItem.data.filter(subItem => !HIDDEN_MENU_NAMES_FOR_NON_ADMIN.includes(subItem.name))
        }
      })
      tempNavList = tempNavList.filter(mainItem => {
        if (mainItem.data && Array.isArray(mainItem.data)) {
          return mainItem.data.length > 0
        }
        return true
      })
    }

    // 最后将处理好的临时数据赋值给navList
    this.navList = tempNavList;

    eventBus.$on('fChangeBreadcrumb', (breadcrumbList) => {
      console.log(breadcrumbList)
      this.breadcrumbPath = breadcrumbList.path
      this.breadcrumbName = breadcrumbList.name
    })
    if (document.body.offsetWidth < 1280) {
      this.clickDisplaySub = false;
    } else {
      this.clickDisplaySub = true;
    }

    this.fSetActive()
  },
  watch: {
    '$route': 'fSetActive', //监听路由变化
    moveDisplaySub(newVal) {
      console.log(newVal)
      if (document.body.offsetWidth < 1280) {
        this.clickDisplaySub = false;
      } else {
        this.clickDisplaySub = true;
      }
    },
    screenWidth(val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = val;
        this.timer = true;
        const that = this;
        setTimeout(function () {
          that.reload(that.screenWidth); //窗口大小变化后执行的方法
          that.timer = false;
        }, 10);
      }
    },

  },
  mounted() {
    const that = this;
    window.onresize = () => (() => {
      window.screenWidth = document.body.offsetWidth;
      that.screenWidth = window.screenWidth;
    })();
  },
  methods: {
    shouldSkipMenuAuthCheck(itemData) {
      if (!itemData) return false
      return NO_AUTH_CHECK_MENU_AUTH_IDS.includes(itemData.authId)
    },
    // 处理菜单选择
    async handleMenuSelect(key, keyPath) {
      // 查找对应的菜单项（二级结构）
      let menuItem = null;
      for (let mainItem of this.navList) {
        if (mainItem.data) {
          for (let subItem of mainItem.data) {
            if (subItem.path === `/${key}`) {
              menuItem = subItem;
              break;
            }
          }
        }
        if (menuItem) break;
      }
      if (menuItem) {
        // 直接进行权限检查并导航，避免重复调用subNavItemClick
        if (!this.shouldSkipMenuAuthCheck(menuItem)) {
          let resPower = await this.fGetSmMenuQx(menuItem.authId)
          if (!resPower.resolve) {
            return this.$message('没有' + menuItem.name + '的权限')
          }
        }
        this.$router.push(menuItem.path);
      }
    },

    refresh(path) {
      // 只在当前激活页面时刷新
      if (path === this.$route.path) {
        this.$nextTick(() => {
          const pageComp = this.$refs.mainView;
          if (pageComp && typeof pageComp.init === 'function') {
            pageComp.init();
          } else {
            // 没有 init 方法可以提示
            // this.$message && this.$message.warning('当前页面未实现init方法');
          }
        });
      } else {
        // 跳转后刷新
        this.$router.push(path);
        this.$nextTick(() => {
          const pageComp = this.$refs.mainView;
          if (pageComp && typeof pageComp.init === 'function') {
            pageComp.init();
          }
        });
      }
    },
    //设置选中状态
    // 设置选中状态
    fSetActive(type) {
      let isRotuer = type
      // 获取地址栏中的路由
      let defaultMenu = window.location.hash.substr(
        window.location.hash.indexOf("/")
      );
      this.activerouter = defaultMenu.split('?')[0].slice(1);
      // 取前缀
      if (this.activerouter.split('_')[0].length > 1) {
        this.activerouter = this.activerouter.split('_')[0]
        isRotuer = 'return'
      }
      // 设置主菜单和子菜单选中状态
      let data = []
      this.firstTitle = '概况'
      this.breadcrumb = '营业概况'

      this.navList.forEach((item) => {
        // 检查是否有子菜单
        if (item.data && item.data.length > 0) {
          item.data.forEach(item1 => {
            if (item1.path == '/' + this.activerouter) {
              data = item1
              // 优先使用navTitle（如果有）
              if (item1.navTitle) {
                const titles = item1.navTitle.split(' / ')
                if (titles.length >= 2) {
                  this.firstTitle = titles[0]
                  this.breadcrumb = titles[1]
                }
              } else {
                this.firstTitle = item.name
                this.breadcrumb = item1.name
              }
              return
            }
            // 检查是否有三级菜单
            if (item1.children && item1.children.length > 0) {
              item1.children.forEach(item2 => {
                if (item2.path == '/' + this.activerouter) {
                  data = item2
                  // 优先使用navTitle（如果有）
                  if (item2.navTitle) {
                    const titles = item2.navTitle.split(' / ')
                    if (titles.length >= 2) {
                      this.firstTitle = titles[0]
                      this.breadcrumb = titles[1]
                    }
                  } else {
                    this.firstTitle = item.name
                    this.breadcrumb = item1.name + ' / ' + item2.name
                  }
                  return
                }
              })
            }
          })
        } else {
          // 没有子菜单的情况，直接匹配主菜单路径
          if (item.path == '/' + this.activerouter) {
            data = {
              id: item.id,
              path: item.path,
              name: item.name
            }
            this.firstTitle = item.name
            this.breadcrumb = item.name
            return
          }
        }
      })
      this.subNavItemClick(data, isRotuer)
    },

    async fNav(path) {
      if (this.api.smCom.fSmIsEmpty(path)) {
        return
      }
      // 权限判断：先找到对应菜单项
      let target = null;
      for (const main of this.navList) {
        if (main.data && Array.isArray(main.data)) {
          target = main.data.find(sub => sub.path === path);
          if (target) break;
        }
      }
      if (target) {
        if (!this.shouldSkipMenuAuthCheck(target)) {
          const resPower = await this.fGetSmMenuQx(target.authId);
          if (!resPower.resolve) {
            this.$message('没有' + target.name + '的权限');
            this.navSelectVal = '';
            return;
          }
        }
      }
      if (path == -1 || path == -2) {
        window.history.go(path)
      } else {
        this.$router.replace(path);
      }
      this.breadcrumbPath = ''
      this.breadcrumbName = ''
      setTimeout(() => {
        this.navSelectVal = ''
      }, 200)
    },
    // 点击主菜单
    navListClick(navItemData) {
      //找到当前的子菜单的数据
      this.subNavItemClick(navItemData);
    },
    // 子菜单的点击事件
    async subNavItemClick(itemData, type) {
      if (!this.shouldSkipMenuAuthCheck(itemData)) {
        let resPower = await this.fGetSmMenuQx(itemData.authId)
        if (!resPower.resolve) {
          return this.$message('没有' + itemData.name + '的权限')
        }
      }
      this.breadcrumbPath = ''
      let navId = itemData.id + '';
      console.log(itemData)

      //取子菜单的id 前两位 取主菜单id
      this.navActSelId = navId.substring(0, 2);
      // 设置主菜单和子菜单选中状态
      this.navList.map(async (item) => {
        if (item.id == this.navActSelId || item.id == itemData.id) {
          item.select = true
          this.floatSubNavList = item.data
          this.fixSubNavList = item.data
          // 默认展开

          if (item.id == this.navActSelId) {
            this.floatSubTitle = item.name
            this.fixSubTitle = this.floatSubTitle
          }
          // 直接跳转
          if (type != 'return') {
            //判断权限
            this.$router.push(itemData.path);
          }
        } else {
          item.select = false
        }
      });

    },

    // 处理无子菜单的菜单项点击事件
    async handleNoSubMenuClick(item) {
      let resPower = await this.fGetSmMenuQx(item.authId)
      if (!resPower.resolve) {
        return this.$message('没有' + item.name + '的权限')
      }

      // 清除所有选中状态
      this.navList.forEach(nav => {
        nav.select = false
      })

      // 设置当前项为选中
      item.select = true

      // 更新面包屑
      this.firstTitle = item.name
      this.breadcrumb = item.name

      // 导航到对应页面（如果有路径）
      if (item.path) {
        this.$router.push(item.path)
      }
    },
    lookForAllId(data = []) {
      for (let item of data) {
        if (String(item.id).length > 4) {
          item.select = false
        }
        if (item.data && item.data.length) {
          this.lookForAllId(item.data)
        }
        if (item.children && item.children.length) {
          this.lookForAllId(item.children)
        }
      }
    },
    // 注销登录
    logout(type) {
      if (type == 'switchMall') {
        this.$router.push("/mall_list");
      }
      if (type == 'logout') {
        this.$store.commit('clearLoginSession');
        this.$router.replace("/login");
      }
    },
    reload(screewidth) {
      if (screewidth < 1280) {
        this.clickDisplaySub = false;
      } else {
        this.clickDisplaySub = true
      }
    },
    fChgLng(item) {
      this.$store.commit('lng', item.value);
      this.$store.commit('lng_name', item.name);

      window.location.reload();
      // this.$forceUpdate()
    },


    // ------------ 请求 开始 -------------

    // 修改密码=确定
    async determineAdd() {

      if (this.api.smCom.fSmIsEmpty(this.newPassword)) {
        return this.$message(this.fLng('请输入新密码', 'login'));
      }
      if (this.api.smCom.fSmIsEmpty(this.confirmPassword)) {
        return this.$message(this.fLng('请输入确认密码', 'login'));
      }
      if (this.newPassword == this.confirmPassword) {
        let res = await this.USER_CHG_PSW()
        this.$message(res.msg);
        if (res.result != "sucess") {
          return
        }
        this.changePassword = false
        setTimeout(() => {
          //返回登录页面
          this.logout('logout')
        }, 2000);
      } else {
        this.$message('确认密码与修改的密码不一致！');
      }
    },
    // 修改密码  USER_CHG_PSW
    async USER_CHG_PSW(oper) {
      let js = {};
      js['OPER'] = 'CHG_PSW'
      js["CHG_ORG_ID"] = this.$store.state.smCloud.org_id; // 修改机构id
      js["CHG_USER_ID"] = this.$store.state.smCloud.user_id; // 修改员工id
      js["ORG_ID"] = this.$store.state.smCloud.org_id; // 必填 机构id
      js["USER_ID"] = this.$store.state.smCloud.user_id; // 必填 员工id
      js['USER_PSW'] = this.newPassword
      let res = await this.api.smCloud.fSmCloudAdminApi({
        methodName: 'ORG_USER_INFO',
        js,
      })
      return res;
    },
    // ------------ 请求 结束 -------------


  },
};
</script>

<style lang="less" scoped>
.el-aside {
  font-size: 16rem;
  height: 100vh;
  background-color: #031A43;

  .logo {
    width: 100%;
    height: 80rem;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: auto;
      height: 40rem;
    }
  }
}

// Element UI 菜单样式覆盖
.el-menu {
  background-color: #031A43;
  border-right: none;
  width: 140rem;
  height: calc(100vh - 80rem);
  overflow-y: auto;
  overflow-x: hidden;

  .el-menu-item,
  .el-submenu__title {

    // height: 48rem;
    // line-height: 48rem;
    color: #c9d7ec;
    padding: 0 16rem;
  }

  .el-menu-item {
    font-size: 14rem;
    display: flex;
    align-items: center;

    &:hover {
      background-color: #02377b;
      color: #fff;
    }

    &.is-active {
      background-color: #007AFB !important;
      color: #fff !important;
    }
  }

  .el-submenu__title {
    font-size: 14rem;
    display: flex;
    align-items: center;

    &:hover {
      background-color: #02377b;
      color: #fff;
    }
  }

  .el-submenu {
    .el-submenu__title {
      background-color: #02377b;

      &:hover {
        background-color: #02377b;
      }
    }

    .el-menu {
      background-color: #02377b;
      width: 200rem;

      .el-menu-item {
        color: #c9d7ec;

        &:hover {
          background-color: #012a5c;
        }

        &.is-active {
          background-color: #005aaf !important;
        }
      }
    }
  }
}

.el-header {
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 20rem;
  font-size: 16rem;
  font-weight: bold;

  .right {
    display: flex;
    align-items: center;
    font-weight: 500;

    img {
      width: 30rem;
      margin-right: 5rem;
      height: 30rem;
      border-radius: 50%;
    }
  }

  .right:hover {
    .edit-pwd {
      display: flex;
    }
  }
}

.el-main {
  background-color: #EBEDF6;
  padding: 10rem;
  padding-top: 5rem;
}


//element-ui 选择器三角
// /deep/.el-select__caret {
//   line-height: 32rem;
// }

// // 选择行高
// /deep/.el-input__icon {
//   line-height: 32rem;
// }

//所有表头背景颜色
/deep/.vxe-table {
  .vxe-table--header-wrapper {
    background: #F5F7FA !important;
  }
}

//element 按钮样式==颜色
/deep/.el-button--primary {
  background-color: #6396FC;
  border-color: #6396FC;
}

// 页选择的背景颜色
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #6396FC;
}

//单选文字颜色
/deep/.el-radio__input.is-checked+.el-radio__label {
  color: #6396FC;
}

//单选按钮颜色
/deep/.el-radio__input.is-checked .el-radio__inner {
  border-color: #6396FC;
  background: #6396FC;
}

//图片样式
img {
  vertical-align: baseline;
}

.breadcrumb-item {
  cursor: pointer;

  &:hover {
    color: #1971FF;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue